<template>
<div id="UserDetail">
    <div class="desc-container">
        <div class="detail-title">
            <div class="title-area">
                {{$t(/*用户名*/'user.username')}}：{{detail.username}}
            </div>
            <div class="btn-area">
                <EditUser btnType="primary" :detail="detail" @change='getUserDetail'/>
                <el-button type="danger" class="ml-10" @click='handleDelete'>{{$t(/*删除*/'c.delete')}}</el-button>
            </div>
        </div>
        <el-row class="detail-desc">
            <el-col :span="8" class="desc-item">
                <div class="key">UID：</div>
                <div class="value">{{detail.uid}}</div>
            </el-col>
            <el-col :span="8" class="desc-item">
                <div class="key">Access Key：</div>
                <div class="value">{{detail.secret_key}}</div>
            </el-col>
            <el-col :span="8" class="desc-item">
                <div class="key">{{$t(/*推送地址*/'user.notify_url')}}：</div>
                <div class="value">{{detail.notify_url}}</div>
            </el-col>
            <el-col :span="8" class="desc-item">
                <div class="key">{{$t(/*路由自定义配置*/'user.addr_profile')}}：</div>
                <div class="value">{{detail.addr_profile}}</div>
            </el-col>
            <el-col :span="8" class="desc-item">
                <div class="key">{{$t(/*MQTT推送*/'user.relay_mqtt_enable')}}：</div>
                <div class="value">{{detail.relay_mqtt_enable}}</div>
            </el-col>
            <el-col :span="8" class="desc-item">
                <div class="key">{{$t(/*创建时间*/'c.create_time')}}：</div>
                <div class="value">{{$U.timeFormat(detail.create_time)}}</div>
            </el-col>
        </el-row>
    </div>
</div>
</template>

<script>
import Core from '../../core'

export default {
    name: "UserDetail",
    components: {
        EditUser: () => import('./components/EditUser.vue'),
    },
    data() {
        return {
            loading: false,

            id: '',
            detail: {},
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.getUserDetail();
    },

    methods: {
        getUserDetail() {
            this.loading = true
            Core.Api.User.detail({user_id: this.id}).then(res => {
                console.log('getUserDetail res:', res)
                this.detail = res.user;
                this.loading = false
            })
        },

        handleDelete() {
			this.$confirm(
                this.$t(/*删除用户后，平台上该用户的所有数据将清除。*/'user.ask_delete_content'),
                this.$t(/*确定要删除该用户吗？*/'user.ask_delete_title'), {
                confirmButtonText: this.$t(/*确定*/'c.confirm'),
				cancelButtonText: this.$t(/*取消*/'c.cancel'),
				type: 'warning'
			}).then(() => {
				Core.Api.User.delete({user_id: this.id}).then(() => {
					this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
					this.$route.go(-1)
				})
			})
		},
    }
}
</script>

<style scoped lang="scss">
// #UserDetail {}
</style>
